// Загрузка картинок в облако. Сеть намеренно живёт здесь, а не в ките:
// ui/ImageUpload — только разметка, запросы ему передают пропом.

import { api } from '@/api/client'

/** Назначение картинки; совпадает с ALLOWED_UPLOAD_PURPOSES на бэкенде. */
export type UploadPurpose = 'club-logo' | 'menu-item'

type Query = Record<string, string | number | boolean | null | undefined> | undefined

/** Загружает файл и возвращает его публичный URL. */
export async function uploadImage(
  file: File,
  purpose: UploadPurpose,
  query?: Query
): Promise<string> {
  const form = new FormData()
  form.append('file', file)
  form.append('purpose', purpose)
  const res = await api.postForm<{ id: string; url: string }>('/v1/uploads/image', form, { query })
  return res.url
}

/**
 * Убирает картинку из хранилища. Отсутствующая — не ошибка (ручка идемпотентна).
 * Чужую ссылку (не наш URL) молча игнорируем: удалять там нечего.
 */
export async function deleteImage(url: string, query?: Query): Promise<void> {
  const id = url.split('?')[0].split('/').pop() ?? ''
  if (!/^[0-9a-f-]{36}$/i.test(id)) return
  await api.del(`/v1/uploads/${id}`, { query })
}

/**
 * Привязывает загруженные картинки к клубу. Нужно мастеру создания клуба:
 * логотип грузится до того, как клуб существует, и остался бы ничьим.
 */
export async function attachUploads(urls: string[], clubId: string): Promise<void> {
  const real = urls.filter((u) => u.trim())
  if (real.length === 0) return
  await api.post('/v1/uploads/attach', { urls: real }, { query: { clubId } })
}
